import React, { useState, useEffect } from "react";
import styles from "../../../pages/Home.module.css";
import { useAuth } from "../../context/Auth";
import { Spinner } from "../../icons/Icon";

const InputTag2 = ({
  id,
  labelText,
  placeholderType,
  placeholderText,
  required,
  value,
  onChange,
  star,
  disabled,
  name,
  maxLength,
  loading,
  padding,
}) => {
  const { mode } = useAuth();
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      setInputValue(newValue);
      onChange(e);
    }
  };

  return (
    <div className={styles.login_Form_element}>
      <label
        htmlFor={id}
        className={`${styles.login_Form_label} ${
          mode ? styles.login_Form_label_dark : ""
        }`}
      >
        {labelText}
        {star && <span style={{ color: "red" }}>*</span>}
      </label>
      {loading ? (
        <div
          className={`${styles.loading} ${styles.login_Form_input} ${
            mode ? styles.login_Form_input_dark : ""
          }`}
        >
          <span>
            <Spinner size="15" />
          </span>
        </div>
      ) : (
        <input
          {...(maxLength && { maxLength: Number(maxLength) })}
          name={name}
          id={id}
          type={placeholderType}
          placeholder={placeholderText}
          required={required}
          value={inputValue}
          onChange={handleChange}
          disabled={disabled}
          className={`${styles.login_Form_input} ${
            mode ? styles.login_Form_input_dark : ""
          }`}
          autoComplete={"new-password"}
          style={{
            // border: mode ? "none" : "1px solid #ccc",
            backgroundColor: disabled && "#ccc",
            cursor: disabled && "not-allowed",
            padding: padding && padding,
          }}
        />
      )}
    </div>
  );
};

export default InputTag2;
